(() => {
  'use strict';
  function setup() {
    document.querySelectorAll('[data-casa-collections]').forEach(section => {
      if (section.dataset.casaReady) return;
      section.dataset.casaReady = 'true';
      const buttons = [...section.querySelectorAll('[data-casa-tab]')];
      const panels = [...section.querySelectorAll('[data-casa-panel]')];
      function select(value) {
        if (!panels.some(panel => panel.dataset.casaPanel === value)) return;
        panels.forEach(panel => { panel.hidden = panel.dataset.casaPanel !== value; });
        buttons.forEach(button => {
          const active = button.dataset.casaTab === value;
          button.classList.toggle('active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      }
      buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.casaTab)));
      section.addEventListener('shopify:block:select', event => select(event.detail.blockId));
      select('main');
    });
  }
  setup();
  document.addEventListener('shopify:section:load', setup);
})();

(()=>{let generation=0;document.addEventListener('cart:update',async()=>{const own=++generation;const script=document.querySelector('script[data-cart-json]');if(!script)return;try{const response=await fetch(script.dataset.cartJson,{headers:{Accept:'application/json'}});if(!response.ok)return;const cart=await response.json();if(own===generation)document.querySelectorAll('[data-casa-cart-count]').forEach(el=>el.textContent=cart.item_count);}catch{}});})();

